import { render, staticRenderFns } from "./JagfxTrailer.vue?vue&type=template&id=14905926&"
import script from "./JagfxTrailer.vue?vue&type=script&lang=js&"
export * from "./JagfxTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports